import styled from 'styled-components';

const ghostDisabledArrows = `
    .ant-btn-background-ghost[disabled],
    .ant-btn-background-ghost[disabled]:hover {
        border-color: transparent !important;
        background: transparent !important;
        opacity: 0.35;
        box-shadow: none;
    }
`;

export const ArticleRowEditor = styled.div`
    border: ${(props) => props.theme.DefaultBorder};
    background: #fff;
    padding: 0;
`;

export const ArticleRowHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.3rem 0.5rem 0.3rem 0.75rem;
    border-bottom: ${(props) => props.theme.DefaultBorder};
`;

export const ArticleRowTitle = styled.span`
    font-size: ${(props) => props.theme.FontSizeSm};
    color: ${(props) => props.theme.TextColorMuted};
    text-transform: uppercase;
    font-weight: 400;
`;

/** Title + layout popover trigger (pen) */
export const ArticleRowTitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    min-width: 0;
`;

export const ArticleRowActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;

    ${ghostDisabledArrows}
`;

export const ArticleRowBody = styled.div`
    padding: 0.75rem;
`;

export const ArticleColumnsGrid = styled.div`
    display: grid;
    grid-template-columns: var(--article-row-grid-template, minmax(0, 1fr));
    gap: 0.75rem;

    @media (max-width: 900px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;
